import {
  ChangeDetectorRef,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  HostListener,
} from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
import { CatEditService } from 'src/app/services/cat-edit.service';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { UserDashboardService } from 'src/app/services/user-dashboard.service';
import { OrderConfirmationDetailsComponent } from 'src/app/shared-components/order-confirmation-details/order-confirmation-details.component';
import { DataTransferService } from '../data-transfer.service';
import { DateFormetService } from 'src/app/services/dateFormet.service';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { PrimeNG } from 'primeng/config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { buildOrderFileName } from 'src/app/shared-components/order-file-name.util';

@Component({
    selector: 'app-cat-edit-form',
    templateUrl: './cat-edit-form.component.html',
    styleUrls: ['./cat-edit-form.component.scss'],
    standalone: false,
})
export class CatEditFormComponent implements OnInit {
  @ViewChild('reviewOrder') reviewOrder: TemplateRef<any>;
  @ViewChild('paymentScreen') paymentScreen: TemplateRef<any>;
  reviewOrderData: any;
  selectedBranch: any;
  showProductDetails: boolean = true;
  showEditTemplate: boolean = false;
  showEstampDetails: boolean = false;
  showEsignDetails: boolean = false;
  showConfirmation: boolean = false;
  aadhaar_validation: any;
  //-------------------------Step Active --------------------------------------//
  active_product: boolean = false;
  active_template: boolean = false;
  active_eStamp: boolean = false;
  active_eSign: boolean = false;
  active_confirm: boolean = false;
  //-------------------Import & export variables ----------------------------//
  productDetailsData: any;
  sendEditTemplateData: any;
  editTemplateData: any;
  estampData: any;
  revertedStampData: any;
  esignData: any = { toBeEsigned: true };
  orderConfirmationData: any = { service: 'CAT-Edit' };
  @ViewChild('orderDetails') orderDetails!: OrderConfirmationDetailsComponent;
  order_reviewer: any;
  otp_validation: boolean;
  userRole: string;
  paymentDetails: {
    payeeName: string;
    payeeEmail: string;
    payeeMobileNumber: string;
    payNow: string;
    paymentMethod: string;
  };

  paymentOrderData: any;
  order_payment: boolean = true;
  stateCode: string = '';
  isSignerEnable: any;
  account_id: any;
  //------------------------------------------------------------------------------//
  constructor(
    private router: Router,
    private userDashboardService: UserDashboardService,
    private messageService: MessageService,
    private catEditService: CatEditService,
    private catUploadService: CatUploadService,
    private storageService: StorageService,
    private loader: LoaderService,
    private dataTransfer: DataTransferService,
    private dateFormetService: DateFormetService,
    private confirmationService: ConfirmationService,
    private primeng: PrimeNG,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
  ) {
    this.storageService.setContractType(false);
    this.storageService.setContractNumbere('003');
    this.storageService.setDocumentType('003');

    this.order_reviewer = this.storageService.getOrderReviewConsent() || null;
    this.otp_validation = this.storageService.getOtpValidation() ? true : false;
    this.userRole = this.storageService.getRole() || null;
    this.aadhaar_validation = this.storageService.getAdharEdit() || null;

    this.storageService.getSignerValue.subscribe((res) => {
      this.isSignerEnable = res;
    });
  }

  ngOnInit(): void {
    this.account_id = this.storageService.getAccountId() || null;
    this.primeng.ripple.set(true);
    this.otp_validation = this.storageService.getOtpValidation() ? true : false;
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event) {
    event.preventDefault();
    event.returnValue = false;
  }

  //-------------------Import & export Data from parent to child and vice-versa ----------------------------//

  onproductDetailsChange(data: any): void {
    const template_id = data.documentType.id;
    const referenceNumber = data.referenceNumber;
    const params = `?account_id=${this.account_id}&template_id=${template_id}`;
    this.catEditService.getTemplate(params).subscribe((res: any) => {
      console.log(res);
      const template_data = res?.content?.[0]

      if (template_data) {
        template_data.template_html = template_data.template_html.replace(
          /<body([^>]*)>/,
          '<body$1 style="zoom: 0.70;">',
        );
        this.productDetailsData = template_data;
        this.sendEditTemplateData = template_data;
        this.productDetailsData = {
          ...template_data,
          referenceNumber: referenceNumber,
        };
        if (template_data.form != undefined) {
          this.sendEditTemplateData.data.form = this.editTemplateData?.form;
          this.sendEditTemplateData.data.html = this.editTemplateData?.html;
        }

        this.gotToCatEditScreen('editTemplate');
        this.cdr.detectChanges();
      }
    });
  }

  oneditTemplateChange(data: any): void {
    this.editTemplateData = data;
    this.esignData.pdfData = this.editTemplateData.pdfData;
    const value = this.editTemplateData.page;
    this.gotToCatEditScreen(value);
  }
  changeState(data: any) {
    this.selectedBranch = this.storageService.getBranch() || null;
    this.productDetailsData = data;
  }

  onestampDataChange(data: any): void {
    this.estampData = data;
    this.revertedStampData = data;
    if (data.isEstamped) {
      if (!data.state_code) {
        this.stateCode = data.selectedState.state_code;
      } else {
        this.stateCode = data.state_code;
      }
    }
    const value = this.estampData.page;
    if (value === 'editTemplate') {
      this.sendEditTemplateData.form = this.editTemplateData.form;
      this.sendEditTemplateData.html = this.editTemplateData.html;
    }
    this.gotToCatEditScreen(value);
  }

  onesignDataChange(data: any): void {
    this.order_payment = data.paymentbySigner;
    this.paymentDetails = {
      payeeName: data.payeeName,
      payeeEmail: data.payeeEmail,
      payeeMobileNumber: data.payeeMobileNumber,
      payNow: data.payNowOrLater,
      paymentMethod: data.paymentMethod,
    };
    this.esignData = data;

    const value = this.esignData.page;
    if (value === 'estamp') {
      this.esignData.toBeEsigned = true;
      this.estampData = this.revertedStampData;
      this.gotToCatEditScreen(value);
    } else {
      this.setAllOrderDetails();
    }
  }

  setAllOrderDetails() {
    this.estampData.branch
      ? (this.selectedBranch = this.estampData.branch)
      : (this.selectedBranch = this.storageService.getBranch() || null);

    this.estampData = this.estampData.map((estamp) => {
      const { page, ...rest } = estamp;
      return rest;
    });

    const esignsDetals = {
      party_users: this.esignData.party_users
        ? [...this.esignData.party_users]
        : [], // Clone the array
      witness_users: this.esignData.witness_users
        ? [...this.esignData.witness_users]
        : [], // Clone the array
    };

    if (esignsDetals.party_users.length) {
      esignsDetals.party_users = esignsDetals.party_users.map((element) => {
        return {
          name: element.name,
          email: element.email,
          aadhaar_digits:
            element.method === 'AADHAAR' && this.aadhaar_validation
              ? element.aadhaar_digits
              : '',
          contact_number: element.contact_number,
          sign_position: element.sign_position,
          method: element.method,
          position_details: element.position_details,
          is_authorised: !!element.is_authorised,
          authorised_for: element.is_authorised ? (element.authorised_for || '') : '',
          pages: element.pages,
          signatory_sequence: element.signatory_sequence,
          send_document: element.send_document,
          send_notification: element.send_notification,
          remark: element.remark,
          reminder: element.reminder,
          schedule_timestamp: this.dateFormetService.formatDateTime(
            element.schedule_timestamp,
          ),
          server_side_siganture: element.server_side_siganture,
          estamp_sign: (this.storageService.getStampSignatory() && this.storageService.getDocumentToBeStamped() !== false) ? (element.estamp_sign || false) : false,
          esign_otp: this.otp_validation,
          cc_emails: [
            this.esignData.carbon_copy_0,
            this.esignData.carbon_copy_1,
          ].filter((email) => !!email),

          sign_mode:
            element.method === 'DSC'
              ? 'USB-Token'
              : element.method === 'ELECTRONIC'
                ? ''
                : element.sign_mode,
        };
      });
    }

    const orderData = {
      referance_id: this.productDetailsData.referenceNumber,
      account_id: this.account_id,
      branch_id: this.selectedBranch.id,
      template_value: this.editTemplateData,
      estamps: this.estampData,
      esigns: esignsDetals,
    };

    if (
      orderData.estamps.length === 0 &&
      orderData.esigns.party_users.length === 0 &&
      orderData.esigns.witness_users.length === 0
    ) {
      this.messageService.add({
        severity: 'error',
        detail: 'Estamp and E-sign details cannot be empty',
      });
      return;
    }

    const data = {
      template_id: this.productDetailsData.id,
      is_bulk: false,
      file_name: buildOrderFileName(
        this.productDetailsData.referenceNumber,
        this.productDetailsData.name ?? null,
      ),
      order_details: [orderData],
    };
    if (this.order_reviewer) {
      // this.confirmOrder(data);
      const reviewData = { serviceType: 'Contract Edit', details: data };
      this.reviewOrderData = reviewData;
      this.onApproveMethod();
    } else if (this.isSignerEnable && this.order_payment) {
      this.getPayment(data);
      const reviewData = { serviceType: 'Contract Edit', details: data };
      this.reviewOrderData = reviewData;
    } else {
      this.placeOrderData(data);
    }
  }

  // confirmOrder(data) {
  //   this.confirmationService.confirm({
  //     message: 'Do you want to get your request to be reviewed by Checker?',
  //     header: 'Confirmation',
  //     icon: 'pi pi-exclamation-circle',
  //     accept: () => {
  //       this.placeOrderData(data);
  //     },
  //     acceptLabel: 'No , Proceed to Place Order',
  //     acceptIcon: 'pi pi',
  //     reject: (type) => {
  //       switch (type) {
  //         case ConfirmEventType.REJECT:
  //           this.onApproveMethod();
  //           break;
  //         case ConfirmEventType.CANCEL:
  //           break;
  //       }
  //     },
  //     rejectLabel: 'Yes',
  //     rejectIcon: 'pi pi'
  //   });
  // }
  closeModel() {
    this.modalService.dismissAll();
  }

  reviewOrderDataChange(data: any) {
    this.closeModel();
    if (data.path === 'order') {
      this.placeOrderData(data.details);
    }
  }

  onApproveMethod() {
    this.modalService
      .open(this.reviewOrder, {
        // Use this.reviewOrder directly
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        },
      );
  }

  placeOrderData(data: any) {
    if (this.order_payment && this.isSignerEnable) {
      this.getPayment(data);
    } else {
      this.catEditService.postOrder(data).subscribe(
        (res) => {
          if (res) {
            this.getOrderConfirmation(res.content.order_id);
            this.messageService.add({
              severity: 'success',
              detail: 'Order Placed Successfully!',
            });
            this.gotToCatEditScreen('confirmation');
          }
        },
        (err) => {
          if (err?.error?.content?.errors) {
            for (const errorMessage of err.error.content.errors) {
              this.messageService.add({
                severity: 'error',
                detail: errorMessage,
              });
            }
          } else {
            this.messageService.add({
              severity: 'error',
              detail:
                err?.error?.message ||
                err?.message ||
                'Unable to place the CAT Edit order',
            });
          }
        },
      );
    }
  }

  getOrderConfirmation(orderId) {
    this.loader.show();
    let reqParams = {
      order_ids: orderId.toString(),
      detail: 1,
    };
    this.catEditService
      .getOrderConfirmation(reqParams)
      .subscribe((res: any) => {
        if (res.status === 200) {
          this.catUploadService.orderDetails = res.content[0].order;
          this.orderDetails.getPlacedOrderDetails();
        }
      });
  }

  onOrderConfirmationChange(data: any): void {
    this.orderConfirmationData = data;
  }

  //-------------------------------------------------------------------------------------------------//

  //-------- to Display the required component depending on the click of the stepper------------//

  gotToCatEditScreen(value: string): void {
    this.showProductDetails = value === 'product';
    this.showEditTemplate = value === 'editTemplate';
    this.showEstampDetails = value === 'estamp';
    this.showEsignDetails = value === 'esign';
    this.showConfirmation = value === 'confirmation';
    this.setActiveTab(value);
  }

  //------------Change the color of the stepper on completion ------------------------------//

  setActiveTab(value: string) {
    if (value === 'product') {
      this.active_product = false;
      this.active_template = false;
      this.active_eStamp = false;
      this.active_eSign = false;
      this.active_confirm = false;
    } else {
      this.active_product = true;
      this.active_template = value !== 'editTemplate';
      this.active_eStamp = value !== 'editTemplate' && value !== 'estamp';
      this.active_eSign =
        value !== 'editTemplate' && value !== 'estamp' && value !== 'esign';
      this.active_confirm = value === 'confirmation';
    }
  }

  gotoDashboard() {
    this.router.navigate(['doqfy/dashboard']);
  }

  back() {
    this.userRole === 'CLIENT'
      ? this.router.navigate(['doqfy/dashboard'])
      : this.router.navigate(['doqfy/admin-dashboard']);
  }

  selectTemplate() {
    this.dataTransfer.setData(this.productDetailsData);
    this.router.navigate(['/doqfy/cat-edit/bulk-upload']);
  }

  //------------------------------------Payment Option --------------------------------//

  getPayment(Obj) {
    this.paymentOrderData = {
      orderDetails: Obj,
      payment: this.paymentDetails,
      stateCode: this.stateCode,
      service_type: 'Cat-Edit',
    };

    this.modalService
      .open(this.paymentScreen, {
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        },
      );
  }

  paymentOrderDataChange(event) {
    if (event.status === 200) {
      this.messageService.add({
        severity: 'success',
        summary: 'Order Placed successfully!',
        detail: event.message,
      });
      this.closeModel();
    }
  }
  //-------------------------------------------------------------------------------------//
}
